// Homepage "Explore" grid — one card per section page so the teaser homepage still leads everywhere.
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowRight, BedDouble, Sparkles, Images, Rotate3d, MapPin, Star, HelpCircle, Mail, Compass } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { SECTIONS, sectionPath } from '../siteRoutes';

const ICONS = { rooms: BedDouble, amenities: Sparkles, gallery: Images, 'virtual-tour': Rotate3d, location: MapPin, reviews: Star, faq: HelpCircle, contact: Mail, 'ulcinj-guide': Compass };

const ExploreGrid = ({ exclude = [] }) => {
  const { t } = useLanguage();
  const { pathname } = useLocation();
  const cards = SECTIONS.filter((s) => !exclude.includes(s.slug)).map((s, i) => {
    const Icon = ICONS[s.slug];
    return (
      <Link key={s.slug} to={sectionPath(s.slug, pathname)} style={{ animationDelay: `${i * 60}ms` }}
        className={`group relative rounded-2xl border border-white/10 bg-white/[0.04] backdrop-blur p-6 hover:bg-orange-500/10 hover:border-orange-400/40 transition-[background-color,border-color,transform] duration-300 hover:-translate-y-1 ${i === 0 ? 'lg:col-span-2' : ''}`}
        data-testid={`explore-card-${s.slug}`}>
        <Icon className="w-7 h-7 text-orange-400 mb-4" />
        <h3 className="text-lg font-semibold text-white">{t(s.titleKey)}</h3>
        <p className="text-sm text-gray-400 mt-1 line-clamp-2">{t(s.descKey) !== t(s.titleKey) ? t(s.descKey) : ''}</p>
        <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-orange-400 group-hover:gap-2 transition-[gap]">
          {t('common.learnMore')} <ArrowRight className="w-4 h-4" />
        </span>
      </Link>
    );
  });
  return (
    <section id="explore" className="py-20 bg-[#0f1318]" data-testid="explore-section">
      <div className="container mx-auto px-4">
        <p className="text-orange-400 text-xs uppercase tracking-widest font-semibold mb-2">Hotel La Rosa Negra</p>
        <h2 className="text-base md:text-lg text-gray-300 mb-8 max-w-xl">{t('amenities.subtitle')} · {t('gallery.subtitle')} · {t('location.subtitle')}</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">{cards}</div>
      </div>
    </section>
  );
};

export default ExploreGrid;
